import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);

const apply = (mode) => {
    const root = document.documentElement;
    let effective = mode;
    if (mode === "system") {
        effective = window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    if (effective === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
};

export const ThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => localStorage.getItem("vf_theme") || "light");

    useEffect(() => {
        apply(mode);
        localStorage.setItem("vf_theme", mode);
        if (mode !== "system") return;
        // Re-apply when system preference changes
        const mq = window.matchMedia("(prefers-color-scheme: dark)");
        const handler = () => apply("system");
        mq.addEventListener?.("change", handler);
        return () => mq.removeEventListener?.("change", handler);
    }, [mode]);

    const setTheme = useCallback((next) => setMode(next), []);
    const toggle = useCallback(() => setMode((t) => (t === "dark" ? "light" : "dark")), []);

    return (
        <ThemeContext.Provider value={{ theme: mode, setTheme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
